module.exports = __webpack_public_path__ + "static/media/solid_gaming.53c03f60.png";